import type { HealthFeatureConfig } from '../../../types/insurances/HealthFeatureConfig';

export const health: HealthFeatureConfig = {
    overview: {
        details: {
            showVariant: true,
            showContractNumber: true,
            showContractHolder: true,
            fallbackAssistancePhonesKey: 'RO_HEALTH',
            fallbackAssistanceEmailsKey: 'RO_HEALTH',
            showCard: false,
        },
    },
    settings: {
        details: {
            showStatus: true,
        },
    },
};
